"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNavKey = exports.default = void 0;
var _NavCacheCookieManager = _interopRequireDefault(require("./NavCacheCookieManager"));
var _webStorage = _interopRequireDefault(require("./webStorage"));
var _getAppConfig = _interopRequireDefault(require("../constants/getAppConfig"));
var _schemaVersion = require("../constants/schemaVersion");
const navCachePrefix = 'nav-';
const webStorage = (0, _webStorage.default)();
const getNavKey = (locale, hp2Migrate) => "".concat(navCachePrefix).concat(locale).concat(hp2Migrate ? '-hp2' : '', "-").concat(_schemaVersion.SCHEMA_VERSION);
exports.getNavKey = getNavKey;
const cleanWebStorage = () => webStorage.removeAllWithPrefix(navCachePrefix);
const navCache = {
  load: _ref => {
    let {
      locale,
      hp2Migrate
    } = _ref;
    const cached = _NavCacheCookieManager.default.navIsCachedForThisDomain() ? webStorage.get(getNavKey(locale, hp2Migrate)) : null;
    if (!cached) {
      // we clean up old on no match - probable language change or new version
      cleanWebStorage();
      return undefined;
    }
    const appConfig = (0, _getAppConfig.default)();
    const parsedCache = JSON.parse(cached);
    const {
      isOutage,
      lastUpdated
    } = parsedCache;
    if (isOutage) {
      const diff = Date.now() - lastUpdated;
      const minutes = Math.floor(diff / 60000);
      if (minutes > appConfig.outageRetryInterval) {
        cleanWebStorage();
        return undefined;
      }
    }

    // reset cache at midnight
    const now = new Date();
    const lastUpdatedDate = new Date(lastUpdated);
    if (lastUpdatedDate.toDateString() !== now.toDateString()) {
      cleanWebStorage();
      return undefined;
    }
    return parsedCache;
  },
  save: _ref2 => {
    let {
      locale,
      hp2Migrate,
      items
    } = _ref2;
    _NavCacheCookieManager.default.addNavCacheDomain();
    const key = getNavKey(locale, hp2Migrate);
    const data = JSON.stringify({
      ...items,
      lastUpdated: new Date().getTime()
    });
    webStorage.set(key, data);
  }
};
var _default = exports.default = navCache;